import React from "react";
import Sidebar from "../../Components/Layout/Sidebar";
import SidebarV2 from "../../Components/Layout/SidebarV2";
import { useSelector } from "react-redux";
import {
    MdOutlineDashboard,
    MdOutlineInventory2,
    MdOutlineKeyboardArrowDown,
    MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { BsBox, BsPostage, BsTrash3 } from "react-icons/bs";
import { RiSettings2Line } from "react-icons/ri";
import { LuUserCheck } from "react-icons/lu";
import { GrOverview } from "react-icons/gr";

const RootLayout = () => {

    const role = useSelector(state => state.auth.role);

    const navItems = [
        // Dashboard (admin only)
        ...(role === "admin"
            ? [
                {
                    id: "dashboard",
                    label: "Dashboard",
                    icon: <MdOutlineDashboard size={16} />,
                    path: "/portal/dashboard",
                },
            ]
            : []),

        // Dashboard (admin only)
        ...(role === "admin"
            ? [
                {
                    id: "oveview",
                    label: "Overview",
                    icon: <GrOverview size={16} />,

                    path: "/portal/overview",
                },
            ]
            : []),

        ...(role === "admin"
            ? [
                {
                    id: "trashed-orders",
                    label: "Trashed Orders",
                    icon: <BsTrash3 size={16} />,

                    path: "/portal/trashed-orders",
                },
            ]
            : []),



        ...(role === "admin"
            ? [
                {
                    id: "inventory",
                    label: "Inventory",
                    icon: <MdOutlineInventory2 size={16} />,

                    path: "/portal/inventory",
                },
            ]
            : []),

        // ...(role === "admin"
        //     ? [
        //         {
        //             id: "postage",
        //             label: "Postage",
        //             icon: <BsPostage  size={16} />,

        //             path: "/portal/postage",
        //         },
        //     ]
        //     : []),

        // Orders (all users)
        {
            id: "orders",
            label: "Orders",
            icon: <BsBox size={16} />,
            children: [
                { id: "update-orders", label: "Update Orders", path: "/portal/update-orders" },
                // { id: "add-orders", label: "Add Orders", path: "/portal/add-orders" },
                { id: "confirm-orders", label: "Confirm Orders", path: "/portal/confirm-orders" },
                { id: "print-orders", label: "Print Orders", path: "/portal/print-orders" },
            ],
        },

        // Settings (admin only)
        ...(role === "admin"
            ? [
                {
                    id: "user",
                    label: "User",
                    icon: <LuUserCheck size={16} />,
                    children: [
                        { id: "user", label: "Add User", path: "/portal/user" },
                        // { id: "password", label: "Change Password", path: "/portal/change-password" },
                    ],
                },
                {
                    id: "settings",
                    label: "Settings",
                    icon: <RiSettings2Line size={16} />,
                    path: "/portal/settings",
                },
            ]
            : []),
    ];

    return (
        <>
            {/* <Sidebar /> */}
            <SidebarV2 navItems={navItems} />
        </>
    )


}


export default RootLayout;